import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-checkmark",
  "use": "icon-checkmark-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-checkmark\"><path d=\"M7.1 12.8 3.6 9.4l.8-.8 2.5 2.6 4.7-7.5.8.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol